import { Box, Text, Modal, InjectedModalProps } from 'vvs-uikit'
import { useTheme } from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import GotchiActionButton from 'views/VvsGotchi/components/ActionButton'

import { FullAccountText } from './styles'

const WalletModal: React.FC<InjectedModalProps & { account: string; onAction: () => any }> = ({
  account,
  onAction,
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Modal
      maxWidth="450px"
      background={theme.colors.paleYellow}
      title={t('Your Wallet')}
      headerColor="black"
      {...props}
    >
      <Box mb="3em">
        <Text color="black" fontWeight="600" mb="0.5em">
          {t('Your Wallet')}
        </Text>
        <FullAccountText>{account}</FullAccountText>
      </Box>
      <GotchiActionButton
        onClick={() => {
          onAction()
          props.onDismiss?.()
        }}
      >
        {t('Disconnect Wallet')}
      </GotchiActionButton>
    </Modal>
  )
}

export default WalletModal
